import { render, staticRenderFns } from "./RegPay.vue?vue&type=template&id=3236cfbb&scoped=true&"
import script from "./RegPay.vue?vue&type=script&lang=js&"
export * from "./RegPay.vue?vue&type=script&lang=js&"
import style0 from "./RegPay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegPay.vue?vue&type=style&index=1&id=3236cfbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3236cfbb",
  null
  
)

export default component.exports